const SCENE_HEADER_REGEX = /^###\s+Scène\s+n°\s*\d+:\s*(.*)/;

const parseMarkdown = (markdown: string) => {
  const lines = markdown.split("\n");
  const scenes: { title: string; media: string; interactions: string[] }[] = [];

  let currentScene: any = null;

  for (const line of lines) {
    // Only recognise scene headers in the strict format "### Scène n° X: ..."
    // Everything outside a recognised scene block is ignored, so extra LLM
    // content (notes, recommendations, etc.) never pollutes the graph — whether
    // or not the LLM separates it with --- / -- / horizontal rules.
    const sceneMatch = line.match(SCENE_HEADER_REGEX);
    if (sceneMatch) {
      if (currentScene) {
        scenes.push(currentScene);
      }
      currentScene = { title: sceneMatch[1].trim(), media: "", interactions: [] };
      continue;
    }

    // Nothing to collect outside a scene block
    if (!currentScene) continue;

    if (line.startsWith("#### Média:")) {
      currentScene.media = line.replace("#### Média: ", "");
    } else if (line.startsWith("- ")) {
      // Check if interaction is in bold or not
      const boldMatch = line.match(/\*\*(.*?)\*\*/);
      const regularMatch = line.match(/- (.*?):/);

      if (boldMatch) {
        currentScene.interactions.push(boldMatch[1].trim());
      } else if (regularMatch) {
        currentScene.interactions.push(regularMatch[1].trim());
      }
    }
  }

  if (currentScene) {
    scenes.push(currentScene);
  }

  return scenes;
};

export default parseMarkdown;
